import { BaseAdapter, normalizeRecordResponse, sessionParams } from 'api';
import { formatAuthHeaders } from 'utils';

export const client = new BaseAdapter({ domain: process.env.NEXT_PUBLIC_API_DOMAIN });

export const sessionQuery = async ({ req, params, query }) => {
	const formattedParams = { ...sessionParams, context: query.context ? query.context : ['ssr'] };
	const headers = formatAuthHeaders(req.cookies, { titleCase: false });
	const response = await client.apiRequest({ url: `/session`, headers, params: formattedParams });
	return normalizeRecordResponse(response);
};
